import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import {
  Avatar,
  AvatarTypes,
  TAvatarBackgroundColorIndex,
} from '@gem/call/Removable/components/Avatar/Avatar';

interface ILargeCallAvatarProps {
  avatar: {
    title: string | null;
    url: string | null;
    colorIndex: TAvatarBackgroundColorIndex | null;
  };
}

export const LargeCallAvatar: FC<ILargeCallAvatarProps> = observer(({ avatar }) => {
  return (
    <Avatar
      type={AvatarTypes.Round_40}
      title={avatar.title || ''}
      url={avatar.url}
      backgroundColorIndex={avatar.colorIndex || '0'}
    />
  );
});
